import { IPersonalizedFieldMapperProps, PersonalizedFieldNames } from '../Models/CoveoModels';
export const personalizedFieldMapper: Array<IPersonalizedFieldMapperProps> = [
  {
    displayName: 'OM Confidential',
    fieldName: PersonalizedFieldNames.omconfidential,
    userObjPropName: ['selectedStatCode', 'OMConfidential'],
    coveoFieldName: 'lmcomconfidentialrule',
    advancedQuery: true,
    fieldType: 'bool',
  },
  {
    displayName: 'Stat Code Confidential',
    fieldName: PersonalizedFieldNames.selectedstatconfidential,
    userObjPropName: ['selectedStatCode', 'SubStatConfidential'],
    coveoFieldName: 'lmcselectedstatconfidentialrule',
    advancedQuery: true,
    fieldType: 'bool',
  },
  {
    displayName: 'User Type',
    fieldName: PersonalizedFieldNames.usertype,
    userObjPropName: ['userType'],
    coveoFieldName: 'lmcusertyperule',
    advancedQuery: true,
    fieldType: 'string',
  },
  {
    displayName: 'Role',
    fieldName: PersonalizedFieldNames.role,
    userObjPropName: ['selectedStatCode', 'Role'],
    coveoFieldName: 'lmcrolerule',
    advancedQuery: true,
    fieldType: 'string',
  },
  {
    displayName: 'Tier',
    fieldName: PersonalizedFieldNames.tier,
    userObjPropName: ['selectedStatCode', 'Tier'],
    coveoFieldName: 'lmctierrule',
    advancedQuery: true,
    fieldType: 'string',
  },
  {
    displayName: 'States',
    fieldName: PersonalizedFieldNames.states,
    coveoFieldName: 'lmcstates',
    advancedQuery: false,
  },
  {
    displayName: 'Site',
    fieldName: PersonalizedFieldNames.site,
    coveoFieldName: 'lmcsitename',
    advancedQuery: false,
  },
  {
    displayName: 'Search Source',
    fieldName: PersonalizedFieldNames.source,
    coveoFieldName: 'source',
    advancedQuery: false,
  },
  {
    displayName: 'Content Type',
    fieldName: PersonalizedFieldNames.contenttype,
    coveoFieldName: 'lmccontenttype',
    advancedQuery: false,
  },
  {
    displayName: 'Products',
    fieldName: PersonalizedFieldNames.products,
    coveoFieldName: 'lmcproducttags',
    advancedQuery: false,
  },
  {
    displayName: 'Component Guid',
    fieldName: PersonalizedFieldNames.componentguid,
    coveoFieldName: 'lmccomponentguid',
    advancedQuery: false,
  },
  {
    displayName: 'Tags',
    fieldName: PersonalizedFieldNames.concepts,
    coveoFieldName: 'concepts',
    advancedQuery: false,
  },
  {
    displayName: 'Effective Date',
    fieldName: PersonalizedFieldNames.effectivedate,
    coveoFieldName: 'lmceffectivedate',
    advancedQuery: false,
  },
  {
    displayName: 'Archived',
    fieldName: PersonalizedFieldNames.archived,
    coveoFieldName: 'lmcarchived',
    advancedQuery: false,
  },
  {
    displayName: 'Publish Date',
    fieldName: PersonalizedFieldNames.publishdate,
    coveoFieldName: 'lmcpublishdate',
    advancedQuery: false,
  },
  {
    displayName: 'Headline',
    fieldName: PersonalizedFieldNames.headline,
    coveoFieldName: 'lmcheadline',
    advancedQuery: false,
  },
  {
    displayName: 'Search Description',
    fieldName: PersonalizedFieldNames.searchdescription,
    coveoFieldName: 'lmcsearchdescription',
    advancedQuery: false,
  },
];
export function getCoveoFieldNameByString(
  pFieldName: PersonalizedFieldNames,
): IPersonalizedFieldMapperProps | undefined {
  return personalizedFieldMapper.find((pField: IPersonalizedFieldMapperProps) => pField.fieldName === pFieldName);
}

export function getFieldByCoveoFieldName(pFieldName: string): IPersonalizedFieldMapperProps | undefined {
  return personalizedFieldMapper.find((pField: IPersonalizedFieldMapperProps) => pField.coveoFieldName === pFieldName);
}
